<template>
  <div>
    <el-carousel :height="computeHeight" type="card">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="slider_img" object-fit: contain />
      </el-carousel-item>
    </el-carousel>
    <!-- <div class="solve head-label">
      <div style="text-align: center" class="font_size_24">
        真诚合作 用户至上 吸收发展 勇于创新
      </div>
    </div> -->

    <div id="产品微观" class="head-label" style="margin-top: 50px">
      <div
        style="text-align: center; width: 100%; font-weight: 800"
        class="font_size_24"
      >
        产品介绍
      </div>
    </div>
    <div class="product_mobile">
      <el-row>
        <!-- <el-col :xs="24" :sm="12">
          <div class="product_mobile_content">
            <div class="product_mobile_title font_size_30">
              160 液压半自动热熔焊机（工业款）
            </div>
            <div class="product_font_style product_mobile_content_one">
              采用4cm全铝夹瓦，更稳固耐用
            </div>
            <div class="product_font_style product_mobile_content_two">
              独立温控系统，控温更稳定，大金特氟龙涂料不粘管；
            </div>
            <div class="product_font_style product_mobile_content_two">
              采用三级钮力大功率电机，切铣更稳定；
            </div>
            <div class="product_font_style product_mobile_content_two">
              独立计时器便携拆卸，记录吸热和冷却的时间段，使用更方便；
            </div>
            <div class="product_font_style product_mobile_content_two">
              采用高精度防震压力表，耐低温，压力读数更精准。
            </div>
          </div>
        </el-col> -->

        <el-col style="padding: 40px;text-align:center" :span="12" :xs="24" :sm="12">
          <!-- <img src="./../../assets/product/p1.jpeg" class="product_pc_img" /> -->
          <img src="./../../assets/product/5-1.jpg" class="product_pc_img" />
        </el-col>
        <el-col style="padding: 40px;text-align:center" :span="12" :xs="24" :sm="12">
          <!-- <img src="./../../assets/product/p1.jpeg" class="product_pc_img" /> -->
          <img src="./../../assets/product/5-2.jpg" class="product_pc_img" />
        </el-col>
      </el-row>
    </div>

    <div class="product_pc">
      <el-row>
          <el-col style="padding: 40px;text-align:center" :span="12" :xs="24" :sm="12">
          <!-- <img src="./../../assets/product/p1.jpeg" class="product_pc_img" /> -->
          <img src="./../../assets/product/4-1.jpg" class="product_pc_img" />
        </el-col>
          <el-col style="padding: 40px;text-align:center" :span="12" :xs="24" :sm="12">
          <!-- <img src="./../../assets/product/p1.jpeg" class="product_pc_img" /> -->
          <img src="./../../assets/product/8-1.jpg" class="product_pc_img" />
        </el-col>
        <!-- <el-col :xs="24" :sm="12" style="padding: 10px">
          <img src="./../../assets/product/2.jpeg" class="product_pc_img" />
        </el-col> -->
        <!-- <el-col :xs="24" :sm="12">
          <div class="product_pc_one">
            <div class="product_mobile_title font_size_30">
              手推热熔焊机200-2M
            </div>
            <div style="margin-top: 20px" class="product_font_style">
              适应于在工地、车间，沟槽中连接PE、PP、PVDF管材与管材，管材与管件；
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              全铝加厚机架，4cm全铝夹瓦，带保压稳固螺丝；
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              大功率铁刀，特种橡胶电源线，带弹套保护装置；
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              加厚加热板(不低于18mm) . 特种橡胶电源线，大金特氟龙涂料不粘管。
            </div>
          </div>
        </el-col> -->
      </el-row>
    </div>

    <div class="product_pc">
      <el-row>
          <el-col style="padding: 40px;text-align:center" :span="12" :xs="24" :sm="12">
          <!-- <img src="./../../assets/product/p1.jpeg" class="product_pc_img" /> -->
          <img src="./../../assets/product/8-3.jpg" class="product_pc_img" />
        </el-col>
          <el-col style="padding: 40px;text-align:center" :span="12" :xs="24" :sm="12">
          <!-- <img src="./../../assets/product/p1.jpeg" class="product_pc_img" /> -->
          <img src="./../../assets/product/8-4.jpg" class="product_pc_img" />
        </el-col>
        <!-- <el-col :xs="24" :sm="12">
          <div class="product_pc_one">
            <div class="product_mobile_title font_size_30">
              螺杆热熔焊机250-4M
            </div>
            <div style="margin-top: 20px" class="product_font_style">
              适应于在工地、车间，沟槽中连接PE、PP、PVDF管材与管材，管材与管件；
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              全铝加厚机架，4cm全铝夹瓦，带保压稳固螺丝；
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              大功率铁刀，特种橡胶电源线，带弹套保护装置；
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              加厚加热板(不低于18mm) . 特种橡胶电源线，大金特氟龙涂料不粘管。
            </div>
          </div>
        </el-col> -->
        <!-- <el-col :xs="24" :sm="12" style="padding: 10px">
          <img src="./../../assets/product/3.jpeg" class="product_pc_img" />
        </el-col> -->
      </el-row>
    </div>
    <div style="text-align: center">
      <div class="lookMore" @click="toProduct">查看更多产品</div>
    </div>

    <!-- 关于我们-->
    <div id="关于我们" class="about_me head-label">
      <div style="text-align: center" class="font_size_24">关于我们</div>
    </div>
    <div style="width: 90%; background-color: #d7e8ff; margin: 10px auto">
      <div style="padding: 30px; font-size: 18px; color: rgba(0, 0, 0, 0.6)">
        杭州宣胜焊接设备有限公司成立于2010年，位于美丽的西子湖畔杭州，是一家专业从事PE，HDPE，PPR热塑性管道工程机械的厂家，具有技术先进，功能实用，产品通过CE认证，深受国内外客户的好评。
        经过十多年的发展，公司拥有铸造，精加工，喷塑，钣金，包装等全产业链配套车间，目前已有产品包括2000mm及以下全系列的热熔对焊机、全自动燃气对焊机、全自动电热熔焊机、管件热熔对接机、塑料管道切割工具，以及各种施工专用辅助工具等产品。
        产品畅销全国30多个省，自治区，并出口到中东，东欧，东南亚，中亚等非洲国家。
        公司秉承“真诚合作，用户至上，吸收发展，勇于创新”的企业精神，凭借先进的管理模式、创新的技术优势及制造加工、资金的综合实力，愿与客户精诚合作，建立良好的商业信誉，
        面向新老客户的需求，产品远销世界各地！
      </div>
      <div style="text-align: center; font-size: 18px; font-weight: 800">
        企业文化
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          width: 100%;
          color: rgba(0, 0, 0, 0.6);
        "
      >
        <p class="about_me_p">
          求精：精益求精、追求卓越是宣胜竞争发展的品牌资本，是宣胜用户至上的服务精神，也是员工职业发展的持续指引
        </p>
        <p class="about_me_p">
          真诚：求真务实、诚实守信是宣胜经营的基本商业准则，我们在面对客户、员工及商业伙伴时，要恪守正直坦诚，强调勇于担当，确保言行一致，做到信守承诺。
        </p>
        <p class="about_me_p">
          创新：勇于创新、敢于突破是宣胜保持核心竞争力的源泉，是持续发展的不竭动力。
        </p>
        <p class="about_me_p">
          学习：志存高远、持续学习是宣胜发展的重要基础，提倡主动学习、向实践学习、向标杆学习，鼓励员工把学习作为终身的乐趣和成就。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {
      sliders: [],

      carousel_height: "550px",
    };
  },
  methods: {
    toProduct() {
      this.$router.push({
        path: "/product",
      });
    },
  },
  mounted() {
    this.sliders = [
      {
        img: require("../../../static/slider/9.jpg"),
      },
      {
        img: require("../../../static/slider/8.jpg"),
      },
      {
        img: require("../../../static/slider/10.jpg"),
      },
      {
        img: require("../../../static/slider/8.jpg"),
      },
      {
        img: require("../../../static/slider/13.jpg"),
      },
      {
        img: require("../../../static/slider/14.jpg"),
      },
    ];
  },
  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "550px";
      } else {
        return "250px";
      }
    },
    computeArrowImg() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 450) {
        return require("../../../static/other/arrow.png");
      } else {
        return require("../../../static/other/arrow_down.png");
      }
    },
  },
};
</script>

<style scoped>
.border_parent {
  width: 90%;
  margin: auto;
}

.slider_img {
  height: 500px;
  /* width: 100%; */
  /* border: 1px solid #ccc; */
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.solve {
  margin-top: 30px;
  margin-bottom: 10px;
}

.border {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  height: auto;
  margin: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.border_one {
  margin-left: 0;
}

.border_img_parent {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.product_mobile_content {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.product_mobile_img {
  width: 100%;
}

.product_mobile_title {
  font-weight: bold;
  text-align: center;
}

.product_pc_one {
  text-align: center;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.font_size_30 {
  font-size: 1.875em;
}

.product_font_style {
  font-size: 1.125em;
}

.product_pc_img {
  width: 100%;
  /* height: 800px; */
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.product_pc_img:hover {
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.product_pc_img_div {
  width: 50%;
  float: left;
  display: flex;
  align-items: center;
}

.product_pc {
  display: flex;
  width: 90%;
  margin: 20px auto;
  background: #d7e8ff;
  align-items: center;
}

.product_spec_title {
  margin-top: 30px;
  margin-bottom: 10px;
}

.product_spec_parent {
  display: flex;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.cooperation_parent {
  display: flex;
  justify-content: center;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.border_spec {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  float: left;
  width: 25%;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
  font-size: 1.25em;
  font-weight: normal;
  padding: 0 20px;
  margin: 10px;
}

.border_title {
  font-family: "PingFang SC";
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: bold;
  text-align: center;
}

.border_content_one {
  margin-top: 20px;
  font-size: 1.125em;
  text-align: center;
}

.border_content_two {
  margin-top: 5px;
  font-size: 1.125em;
  margin-bottom: 25px;
  text-align: center;
}

.img_border {
  margin-top: 15px;
  width: 80px;
  height: 80px;
}

.border_spec_inner_one {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
  height: 70px;
}

.border_spec_content_one {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  text-align: center;
}

.border_spec_inner_last {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  margin-bottom: 25px;
  text-align: center;
}

.cooperation {
  margin-top: 30px;
  width: 100%;
}

.about_me {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 100%;
}

.product_mobile {
  width: 90%;
  align-items: center;
  margin: 20px auto;
  background: #d7e8ff;
}

.product_mobile_img_div {
  width: 50%;
  height: auto;
}

.product_mobile_content_one {
  margin-top: 20px;
  text-align: center;
}

.product_mobile_content_two {
  margin-top: 10px;
  text-align: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .slider_img {
    height: 220px;
    /* width: 100%; */
  }

  .border_parent {
    display: flex;
    width: 90%;
    margin: auto;
    height: auto;
    flex-direction: column;
  }

  .border {
    border-radius: 6px;
    border: 1px solid #ebeef5;
    float: left;
    width: 100%;
    height: auto;
    margin: 10px 0 auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    /*background: aquamarine;*/
  }

  .border_img_parent {
    margin-top: 0;
  }

  .product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    height: auto;
    background: #f2f6fc;
  }

  .product_mobile_content {
    width: 100%;
  }

  .product_mobile_content_one {
    margin-top: 5px;
  }

  .product_mobile_content_two {
    margin-top: 5px;
  }

  .product_mobile_img_div {
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .product_mobile_img {
    float: left;
  }

  .product_mobile_title {
    font-weight: bold;
  }

  .product_pc_one {
    width: 100%;
    margin-top: 15px;
  }

  .font_size_30 {
    font-size: 1.25em;
  }

  .product_font_style {
    text-align: left;
    font-size: 1em;
    padding: 5px;
  }

  .product_pc_img {
    width: 100%;
    height: 400px;
    /* width: 320px; */
  }

  .product_pc_img_div {
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }

  .product_pc {
    display: flex;
    width: 90%;
    height: auto;
    margin: 20px auto;
    background: #f2f6fc;
    flex-direction: column;
  }

  .head-label {
    display: flex;
    margin-top: 10px;
  }

  .product_spec_parent {
    display: flex;
    width: 90%;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: auto;
    flex-direction: column;
  }

  .border_spec {
    float: left;
    height: auto;
    margin: 8px;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .border_title {
    font-family: "PingFang SC";
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: bold;
  }

  .border_content_one {
    margin-top: 5px;
    font-size: 1.125em;
  }

  .border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 8px;
  }

  .img_border {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
    /*background-color: aqua;*/
    height: 70px;
  }

  .border_spec_content_one {
    margin-top: 5px;
    font-size: 1.125em;
    float: left;
  }

  .border_spec_inner_last {
    /*background-color: bisque;*/
    margin-top: 5px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 8px;
  }

  .about_me {
    display: flex;
    margin-top: 10px;
    width: 100%;
  }
}

.border_spec_img {
  width: 75px;
  height: 55px;
  align-self: center;
}

.font_size_24 {
  font-size: 1.2em;
}

.lookMore {
  align-items: center;
  appearance: none;
  background-color: #3eb2fd;
  background-image: linear-gradient(1deg, #4f58fd, #df002e 99%);
  background-size: calc(100% + 20px) calc(100% + 20px);
  border-radius: 100px;
  border-width: 0;
  box-shadow: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-family: CircularStd, sans-serif;
  font-size: 1rem;
  height: auto;
  justify-content: center;
  line-height: 1.5;
  padding: 6px 20px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s, background-position 0.2s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
}
.lookMore:active,
.lookMore:focus {
  outline: none;
}

.lookMore:hover {
  background-position: -20px -20px;
}

.lookMore:focus:not(:active) {
  box-shadow: rgba(40, 170, 255, 0.25) 0 0 0 0.125em;
}
</style>